import { START_WITH_SPACE } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const CategoryEditSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .max(255)
    .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>)
    .matches(START_WITH_SPACE, {
      message: <Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>,
    }),
  thumbnail: Yup.array().min(1, <Translation>{(t) => t('VALIDATE.REQUIRED_FILE')}</Translation>),
  background: Yup.array().min(1, <Translation>{(t) => t('VALIDATE.REQUIRED_FILE')}</Translation>),
})

export default CategoryEditSchema
